module.exports = __webpack_public_path__ + "static/media/gallery12.bb0db081.jpg";